module.exports = __webpack_public_path__ + "static/media/liquid_22_detail_03.e967f832.jpg";